import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';


class DeleteFileModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { openModal, closeModal, fileToDelete, handleDeleteFile, deleteFileInProgress } = this.props;
    return (
      <Modal show={openModal === 'DeleteFileModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!deleteFileInProgress && (
            <span>Are you sure you want to permanently delete file {(fileToDelete || {}).name}?</span>
          )}
          {deleteFileInProgress && (
            <span>Loading ...</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" bsStyle="default" onClick={closeModal} disabled={deleteFileInProgress}>
            <span className="ti ti-close" /> Cancel
          </Button>
          {' '}
          <Button type="button" bsStyle="primary" onClick={() => handleDeleteFile(fileToDelete)} disabled={deleteFileInProgress}>
            <span className="ti ti-check" /> Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(DeleteFileModal);



// WEBPACK FOOTER //
// ./src/components/routes/files/DeleteFileModal.js